import { render, staticRenderFns } from "./P2PPaymentView.vue?vue&type=template&id=43822964"
import script from "./P2PPaymentView.vue?vue&type=script&lang=js"
export * from "./P2PPaymentView.vue?vue&type=script&lang=js"
import style0 from "./P2PPaymentView.vue?vue&type=style&index=0&id=43822964&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports